const demo = {
  // common translations

  PageTitle: "Wählen Sie einen Beispiel Datensatz für Ihre Experimente aus",
  NumDatapoints: "Anzahl der Datenpunkte",
  NumFeatures: "Anzahl der Eingangsdaten (Features)",
  TargetDescription: "Zielwert(e)",
  DatasetInformation: "Datensatzinformationen",
  Step1: "1. Vorverarbeitung des Datensatzes",
  Step2:
    "2. Training eines Regressionsmodells mit automatischer Hyperparameterabstimmung",
  Step3:
    "3. Training eines Fehlerschätzmodells, das die Unsicherheit des trainierten Regressionsmodells vorhersagt",
  Step4: "4. Generierung von Plots zur Modellbewertung",
  Step5: "5. Bereitstellung eines herunterladbaren und ausführbaren Modells",
  Difficulty: "Experiment-Schwierigkeitsgrad",
  ButtonImportExample: "Beispiel-Datensatz importieren und anzeigen",

  // examples in detail
  examples: {
    dataset1: {
      // Example 1
      Title: "Ermittlung der Milchqualität",
      DatasetFileName: "🐄 Milch Qualität",
      TeaserImageUrl:
        "https://images.pexels.com/photos/3214973/pexels-photo-3214973.jpeg",
      Description:
        "\nBeispieldatensatz für eine KI-Anwendung im Molkereibetrieb. Anhand von Messdaten einzelner Milchproben soll mit Hilfe von KI-Modellen die Güteklasse der Milch bestimmt werden.",
      DifficultyRating: 1,
      NumDatapoints: 200,
      Features: "6 (z.B. pH Wert, Temperatur, Farbe, ...)",
      Targets: "Güteklasse der Milch: 0, 1, 2",
    },
    dataset2: {
      // Example 2
      Title: "Ermittlung der Beton Druckfestigkeit",
      DatasetFileName: "🏗️ Beton Druckfestigkeit",
      TeaserImageUrl:
        "https://images.pexels.com/photos/2628393/pexels-photo-2628393.jpeg?auto=compress&cs=tinysrgb&w=1600",
      Description:
        "\nBeispieldatensatz für eine KI-Anwendung aus der Beton-Herstellung. Die Druckfestigkeit des Betons soll anhand der Mischkomponenten ermittelt werden. Zusätzlich soll durch die Feature-Importance ein neuer Einblick geschaffen werden, welche Eingangsdaten den größten Einfluss auf die Druckfestigkeit haben.",
      DifficultyRating: 2,
      NumDatapoints: 5407,
      NumFeatures: 8,
      Features: "8 (z.B. Hochofenschlacke, Flugasche, Fließmittel, ...)",
      Targets: "Druckfestigkeit in MPa",
    },
    dataset3: {
      // Example 3
      Title: "Tagesvorhersage von Erzeugnissen einer Photovoltaik-Dachanlage",
      DatasetFileName: "☀️ Photovoltaik",
      TeaserImageUrl:
        "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      Description:
        "\nBeispieldatensatz einer KI-Anwendung für eine Photovoltaik-Dachanlage. Mit Hilfe eines KI-Modells soll die Produktion der kommenden 24h anhand von Wettervorhersagedaten vorausgesagt werden.",
      Targets: "24h-Gesamtproduktion in Wattstunden",
      DifficultyRating: 4,
      NumDatapoints: 1977,
      Features: "9 (z.B. Defuse Strahlung, Direkte Strahlung, ...)",
    },
    dataset4: {
      // Example 4
      Title:
        "24h Vorhersage von Erzeugnissen einer Photovoltaik-Dachanlage ⚠️ mit ungeeigneten Daten",
      DatasetFileName: "☀️ Photovoltaik (ungeeignet)",
      TeaserImageUrl:
        "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      Description:
        "\nBeispieldatensatz einer KI-Anwendung für eine Photovoltaik-Dachanlage. Mit Hilfe eines KI-Modells soll die Produktion der kommenden 24h anhand von Wettervorhersagedaten vorausgesagt werden. \n ⚠️ Von diesem Datenset hat es zwei Versionen, dies ist die Version mit ungeeigneten Daten.",
      Targets: "24h-Gesamtproduktion in Wattstunden",
      DifficultyRating: 4,
      NumDatapoints: 1518,
      Features: "9 (z.B. Defuse Strahlung, Direkte Strahlung, ...)",
    },
  },
};

export default demo;
